import { render, staticRenderFns } from "./ClientEdit.vue?vue&type=template&id=13a9b71c&scoped=true&"
import script from "./ClientEdit.vue?vue&type=script&lang=js&"
export * from "./ClientEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClientEdit.vue?vue&type=style&index=0&id=13a9b71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a9b71c",
  null
  
)

export default component.exports